import { SharingDialogStore } from './schema/SharingDialogStore';
import { createStore } from 'satcheljs';

const sharingDialogStore: SharingDialogStore = {
    viewState: {
        isOpen: false,
    },
};

export const getStore = createStore<SharingDialogStore>('sharingDialogStore', sharingDialogStore);
export default getStore;
